import React, { useState, useEffect,useCallback} from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL } from "../Config/Base";
import Select from "react-select";

import plogo from "../Assets/Images/plogo.png";
import found from "../Assets/Images/found.jpg";
import tclogo from "../Assets/Images/tclogo.png";
import teclogo from "../Assets/Images/teclogo.png";
import oat from "../Assets/Images/oat.png";
import Multiselect from "multiselect-react-dropdown";
/*----function with pagination----*/

const pageSize = 3;

const UserViewMain = () => {
  const [selectedOption, setSelectedOption] = useState("");

  // GET request using fetch()

  const token = JSON.parse(localStorage.getItem("usertoken"));
  const [allusers, setAllusers] = useState([]);

  const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);

  const [allVentures, setAllVentures] = useState([]);

  useEffect(() => {
    Getusers();
    GetVenture();
  }, []);

  function Getusers() {
    console.log("Token", token);
    fetch(`${BASE_URL}/User/GetAllUsers`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",

        Accept: "application/json",

        Authorization: "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
      },

      //body:JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Data", data);
        setAllusers(data);
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("SA-users", JSON.stringify(data));
      });

    console.log("check", allusers);
  }

  // const pageCount = allusers ? Math.ceil(allusers.length / pageSize) : 0;
  // if (pageCount === 1)
  // return null;

  // const pages = _.range(1, pageCount + 1);

  // const pagination = (pageNo) => {
  //   setcurrentPage(pageNo);
  //   const startIndex = (pageNo - 1) * pageSize;
  //   const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  //   setpaginatedPosts(paginatedPost);
  // };

  /*---fetch add user----*/

  function fetchParodata() {



    var MultiVentureId = selectedOptions.map(((item) => item.value));
    var MultiVentureName= selectedOptions.map(((item) => item.label));


    console.log(MultiVentureId)
    console.log(MultiVentureName)

    
    let SVentureId = MultiVentureId.toString();
    let SVentureName = MultiVentureName.toString();
    
    console.log(SVentureId)
    console.log(SVentureName)


    let data = {
      username: document.getElementById("username").value,

      email: document.getElementById("email").value,

      password: document.getElementById("password").value,

      roleid: document.getElementById("roleid").value,
      role:"Admin",
      ventureid: SVentureId,

      venturename: SVentureName,
      active: 1,
      deleteStatus: 0,
    };

    axios({
      method: "POST",

      url: `${BASE_URL}/Authenticate/AdminRegister`,

      data,

      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log(response.data);

        if (response.data.status === "Success") {
          alert("User Registered Successfully");

          Paropcloseform();
          Getusers();
        } else if (response.data.status === "UserError") {
          alert("User Already Exist !");
        } else if (response.data.status === "Error") {
          // toast.error("User creation failed !", {

          //   position: "top-center",

          //   autoClose: 3200,

          //   hideProgressBar: false,

          //   closeOnClick: true,

          //   pauseOnHover: true,

          //   draggable: true,

          //   progress: undefined,

          //   className: 'toast-message'

          //   });
          alert("User Creation Failed");
          // setTimeout(() => {

          // }, 5000);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  }

  /*----function with validation----*/

  function handleSubmit(event) {
    event.preventDefault();

    var name = document.getElementById("username").value;
    var mail = document.getElementById("email").value;
    const email1 =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var password = document.getElementById("password").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    var role = document.getElementById("roleid").value;



   

   


    //var venture = document.getElementById("ventureid").value

    if (!name) {
      document.getElementById("nameErr").innerHTML = "Username Required";
    } else if (name.length < 3) {
      document.getElementById("nameErr").innerHTML = " ";
      document.getElementById("nameErrA").innerHTML =
        "Enter Atleast 3 Characters ";
    } else {
      document.getElementById("nameErr").innerHTML = " ";
      document.getElementById("nameErrA").innerHTML = " ";
    }

    if (!mail) {
      document.getElementById("mailErr").innerHTML = "Email Required ";
    } else if (email1.test(document.getElementById("email").value) === false) {
      document.getElementById("mailErrA").innerHTML = "Not Valid Email";
      document.getElementById("mailErr").innerHTML = " ";
    } else {
      document.getElementById("mailErr").innerHTML = "  ";
      document.getElementById("mailErrA").innerHTML = "  ";
    }
    if (!password) {
      document.getElementById("passErr").innerHTML = "Password Required ";
    } else if (
      password1.test(document.getElementById("password").value) === false
    ) {
      document.getElementById("passErrA").innerHTML =
        "Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById("passErr").innerHTML = " ";
    } else {
      document.getElementById("passErr").innerHTML = "  ";
      document.getElementById("passErrA").innerHTML = "  ";
    }

    if (!role) {
      document.getElementById("rolesErr1").innerHTML = "Role Required ";
    } else {
      document.getElementById("rolesErr1").innerHTML = " ";
    }

    if (!selectedOptions) {
      document.getElementById("roleErr").innerHTML = "Venture Required ";
    } else {
      document.getElementById("roleErr").innerHTML = " ";
    }
    if (
      name.length >= 3 &&
      email1.test(document.getElementById("email").value) === true &&
      password1.test(document.getElementById("password").value) === true &&
      role && selectedOptions
    ) {
      fetchParodata();
    }
  }

  function handlechange(event) {
    event.preventDefault();

    var name = document.getElementById("username").value;

    var mail = document.getElementById("email").value;

    const email1 =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    var password = document.getElementById("password").value;

    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    var role = document.getElementById("roleid").value;
    // var venture = document.getElementById("ventureid").value;

    if (!name) {
      document.getElementById("nameErr").innerHTML = "Username Required";
      document.getElementById("nameErrA").innerHTML = " ";
    } else if (name.length < 3) {
      document.getElementById("nameErr").innerHTML = " ";
      document.getElementById("nameErrA").innerHTML =
        "Enter Atleast 3 Characters ";
    } else {
      document.getElementById("nameErr").innerHTML = " ";
      document.getElementById("nameErrA").innerHTML = " ";
    }

    if (!mail) {
      document.getElementById("mailErr").innerHTML = "Mail Required ";
      document.getElementById("mailErrA").innerHTML = "  ";
    } else if (email1.test(document.getElementById("email").value) === false) {
      document.getElementById("mailErrA").innerHTML = "Not Valid Email";
      document.getElementById("mailErr").innerHTML = " ";
    } else {
      document.getElementById("mailErr").innerHTML = "  ";
      document.getElementById("mailErrA").innerHTML = "  ";
    }
    if (!password) {
      document.getElementById("passErr").innerHTML = "Password Required ";
      document.getElementById("passErrA").innerHTML = "  ";
    } else if (
      password1.test(document.getElementById("password").value) === false
    ) {
      document.getElementById("passErrA").innerHTML =
        "Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById("passErr").innerHTML = " ";
    } else {
      document.getElementById("passErr").innerHTML = "  ";
      document.getElementById("passErrA").innerHTML = "  ";
    }

    if (!role) {
      document.getElementById("rolesErr1").innerHTML = "Role Required ";
    } else if (role) {
      document.getElementById("rolesErr1").innerHTML = " ";
    }

    if (!venture) {
      document.getElementById("roleErr").innerHTML = "venture Required ";
    } else {
      document.getElementById("roleErr").innerHTML = " ";
    }
  }

  /*----Function open form----*/

  function Paropopenform() {
    document.getElementById("modalRegisterForm").style.display = "block";
  }

  /*----Function close form----*/

  function Paropcloseform() {
    window.location.reload();

    document.getElementById("modalRegisterForm").style.display = "none";
  }

  /*----Active and Inactive function----*/

  /*----Password function----*/

  function Parohide() {
    var x = document.getElementById("password");

    var eye = document.getElementById("Paroeye");

    if (x.type === "password") {
      x.type = "text";

      eye.classList.remove("fa-eye-slash");

      eye.classList.add("fa-eye");
    } else {
      x.type = "password";

      eye.classList.remove("fa-eye");

      eye.classList.add("fa-eye-slash");
    }
  }

  //  ActiveStatus

  function ActiveStatus(Id, active) {
    const body = {
      id: Id,
    };

    console.log(body);
    let bearer = "Bearer " + JSON.parse(localStorage.getItem("usertoken"));
    axios({
      method: "POST",
      url: `${BASE_URL}/User/ActiveStatus`,
      data: body,
      headers: {
        "Content-Type": "application/json",
        Authorization: bearer,
      },
    }).then((response) => {
      console.log(response.data);
      if (active != 0) {
        //  toast.success("Activated Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        alert("User Activated Successfully");
        //setTimeout(() => {

        Getusers();
        //  }, 1000);
      } else if (active == 0) {
        // toast.success("InActivated Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        alert("User Inactivated Successfully");
        // setTimeout(() => {

        Getusers();
        // }, 1000);
      }
    });
  }

  /*----del btn Onclick func----*/ //ParoDeleteStatus

  function DeleteUser(Id, UserName) {
    var ans = window.confirm("Are you sure want to delete this user?");
    if (ans == true) {
      const body = {
        id: Id,
      };
      console.log("check", body);
      axios({
        method: "DELETE",
        url: `${BASE_URL}/User/DeleteUser`,
        data: body,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + `${token}`,
        },
      }).then((response) => {
        console.log(response.data);
        alert(UserName + "" + "Deleted Successfully !");

        Getusers();
      });
    }
  }

  function closeForm() {
    document.getElementById("DisplayEditPop").style.display = "none";
    document.getElementById("Corpimgform").reset();

    document.getElementById("UpdatecapErrA").innerHTML = " ";
  }

  /*----Get select to the particular Id----*/
  const [EditSaname, SetEditSaname] = useState([]);

  //-----EDIT FUNCTION -----//

  function SaUsernameEdit(Id) {
    document.getElementById("DisplayEditPop").style.display = "block";

    SaSelectfunction(Id);
  }

  /*----UpdateSection----*/

  function updateSaName(Id, UserName) {
    const token = JSON.parse(localStorage.getItem("usertoken"));

    var UserName = document.getElementById("Saname").value;

    if (!UserName) {
      document.getElementById("UpdatecapErrA").innerHTML = "Name Required";
    } else if (UserName) {
      document.getElementById("UpdatecapErrA").innerHTML = " ";
    }

    if (UserName) {
      const body = {
        Id: Id,

        UserName: UserName,
        NormalizedUserName: UserName,
      };
      console.log(body);

      axios({
        method: "POST",

        url: `${BASE_URL}/User/EditUser`,
        data: body,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + `${token}`,
        },
      })
        .then((response) => {
          console.log(response.data);
          if (response.data.status === "Error") {
            alert("Incorrect Username");
          } else if (response.data.status === "Success") {
            alert("Username Updated Successfully");
            Getusers();
            closeForm();
          }
        })

        .catch((error) => {
          console.log(error);
          alert("failed !");
        });
    }
  }

  function SaSelectfunction(Id) {
    const token = JSON.parse(localStorage.getItem("usertoken"));

    const body = {
      id: Id,
    };
    console.log("body", body);

    axios({
      method: "POST",
      url: `${BASE_URL}/User/SelectUser`,
      data: body,
      headers: {
        "Content-type": "application/json",
        Authorization: "Bearer " + `${token}`,
      },
    })
      .then((response) => {
        console.log(response.data);

        SetEditSaname(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [ventureId, SetOldLink] = useState([]);

  function GetVenture() {
    console.log("Token", token);
    fetch(`${BASE_URL}/Venture/GetVentures`, {
      method: "GET",

      headers: {
        "Content-type": "application/json",

        Accept: "application/json",

        Authorization: "Bearer " + `${token}`,

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
      },

      //body:JSON.stringify(data)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Data", data);
        setAllVentures(data);
        //setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      });

    console.log("check", allVentures);
  }

  //-----select venture id

  const [allusers1, setAllusers1] = useState([]);

  const [venture, setVenture] = useState([]);

  function handleVenture() {
    var venture = document.getElementById("venture").value;

    const body = {
      ventureName: venture,
    };
    console.log("body", body);

    axios({
      method: "POST",
      url: `https://localhost:44312/api/Venture/SelectVentureId`,
      data: body,
      headers: {
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        console.log(response.data);

        localStorage.setItem("VentureId", JSON.stringify(response.data));

        let ventureId = JSON.parse(localStorage.getItem("VentureId"));

        let Check = ventureId.map((item) => item.venture_Id);

        let CheckA = Check[0];

        SetOldLink(CheckA);
      })
      .catch((error) => {
        console.log(error);
      });
  }



  // HandleSelect
  const options = allVentures.map(item => {

    return {

        label: item.ventureName,

        value: item.ventureId1,
    

    }

})

  const [selectedOptions, setSelectedOptions] = useState();

  function handleSelect(data) {

    setSelectedOptions(data);

  }

  /*----Main Container----*/


  const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  
  let data = localStorage.getItem("SA-users")
  let transdata =  JSON.parse(data);
  console.log(transdata,'aaaa')
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 5;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 0;
    
      const totalBlocks = totalNumbers + 2;
     
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination">
        <ul className="pagination" id='Paro-pag'>
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`Paropage-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

  return (
    <>
      <div className="Paro-addmain">
        {/*  Toastify */}

        <ToastContainer
          id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="sa-addgrid-layout">
          <div className="sa-addmain-top">
            <div className="sa-addmain-back">
              <Link to="/Superventures ">
                <i class="fa-sharp fa-solid fa-backward"></i>
              </Link>
            </div>
            <span>Users</span>
          </div>
        </div>

        <div className="Paro-addmain-add">
          <button className="Paro-add-user" onClick={Paropopenform}>
            <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add User
          </button>
        </div>
        <div
          className="sapop-fade"
          id="modalRegisterForm"
          tabindex="-1"
          role="dialog"
        >
          <div className="modal-dialog" id="saadduser" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold"> ADD USER</h4>
                <button
                  type="button"
                  className="close"
                  onClick={Paropcloseform}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="modal-body mx-3">
                  <div className="md-form mb-5">
                    <input
                      type="text"
                      className="form-control validate"
                      placeholder="Username"
                      onKeyUp={handlechange}
                      id="username"
                    />
                    <span id="nameErr" className="error"></span>
                    <span id="nameErrA" className="error"></span>
                  </div>

                  <div className="md-form mb-5">
                    <input
                      type="email"
                      className="form-control validate"
                      placeholder="Email"
                      onKeyUp={handlechange}
                      id="email"
                    />
                    <span id="mailErr" className="error"></span>
                    <span id="mailErrA" className="error"></span>
                  </div>

                  <div className="md-form mb-5">
                    <div style={{ display: "flex" }}>
                      <input
                        type="password"
                        className="form-control validate"
                        placeholder="Password"
                        onKeyUp={handlechange}
                        id="password"
                      />
                      <span className="Paro-eyeicon">
                        {" "}
                        <i
                          class="fa fa-eye-slash"
                          aria-hidden="true"
                          onClick={Parohide}
                          id="Paroeye"
                        ></i>
                      </span>
                    </div>

                    <span id="passErr" className="error"></span>
                    <span id="passErrA" className="error"></span>
                  </div>
                  <div className="md-form mb-5">
                    <select
                      name="role"
                      className="form-select"
                      onInputCapture={handlechange}
                      id="roleid"
                    >
                      <option value="">Role</option>
                      <option value="01">Admin</option>
                      {/* <option value="02">User</option> */}
                    </select>
                    <span id="rolesErr1" className="error"></span>
                    {/* <span id="passErrA" className='error'></span>   */}
                  </div>

                  <div className="md-form mb-5">
                    
                  <Select  

                 className="dropdown"
                 options={options}
                 id="OatAselect"
                 placeholder="Venture Name"
                 value={selectedOptions}
                 onChange={handleSelect}
                 isSearchable={true}
                 isMulti
                 isClearable
               />



                    <span id="roleErr" className="error"></span>
                  </div>

                  {/* <div className="md-form mb-5">
                        <select  name="Department"  className="form-select"   id="ventureid">
              <option>Venture Id</option>
            {allVentures.map((e)=>{
      return<option value={e.ventureId1}>{e.ventureId1}</option>})} */}
                  {/* {allusers1.map((e)=>{
          return<option  value=""></option>})} */}
                  {/* </select> 
                    

                  </div>  */}
                </div>

                <div className="modal-footer d-flex justify-content-center">
                  <button className="Paro-adduser-button">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* {
  !paginatedPosts ? ("No data found"):(
    <table className='paromain-table'>
      <thead>
        <tr>

          <th>S.No</th>
          
          <th>Username</th>
     
          <th>Email</th>

          <th>Action</th>

        </tr>

      </thead> */}

        <div className="super-table">
          <div class="super-table-responsive">
            {!paginatedPosts ? (
              "No data found"
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Venture Name</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* mapping to adduser */}

                  {currentData.map((e, index) => {
                    return (
                      <tr key={index}>
                        <td>{e.userName}</td>
                        <td>{e.email}</td>
                        <td>{e.ventureName}</td>

                        <td>
                          {" "}
                          {e.active == 1 ? (
                            <button
                              id="ParoActive-buttonA"
                              onClick={() => ActiveStatus(e.id, e.active)}
                            >
                              Active
                            </button>
                          ) : (
                            <button
                              id="ParoActive-buttonB"
                              onClick={() => ActiveStatus(e.id, e.active)}
                            >
                              Inactive
                            </button>
                          )}
                          &nbsp;{" "}
                        </td>
                        <td style={{whiteSpace:"nowrap"}}>
                          <i
                            class="fa-solid fa-pen-to-square"
                            id="editicon"
                            onClick={() => SaUsernameEdit(e.id)}
                          ></i>
                          <i
                            class="fa-solid fa-trash"
                            id="deleteicon"
                            onClick={() => DeleteUser(e.id, e.userName)}
                          ></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            <br></br>

            <br></br>
{transdata.length<=5? null:<div>
{

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}
</div>}


            {/* <nav>
              <ul className="pagination">
                {pages.map((page) => (
                  <li
                    className={
                      page === currentPage ? "page-item active" : "page-item"
                    }
                  >
                    <p className="page-link" onClick={() => pagination(page)}>
                      {page}
                      {page <= 1 ? "" : ""}
                    </p>
                  </li>
                ))}
              </ul>
            </nav> */}

          </div>
        </div>

        {/* EditPopup */}

        <div className="Paropop-fade" id="DisplayEditPop">
          {EditSaname.map((e) => {
            return (
              <div
                className="modal-dialog"
                role="document"
                id="CorpcenterEditform"
              >
                <div className="modal-content">
                  <div className="modal-header text-center">
                    <h4 className="modal-title w-100 font-weight-bold">EDIT</h4>
                    <button type="button" className="close" onClick={closeForm}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <form
                    id="Corpimgform"
                    onSubmit={() => updateSaName(e.id, e.userName)}
                  >
                    <div className="modal-body mx-3">
                      <div className="md-form mb-5">
                        <label id="ParoSectionTable">UserName</label>
                        <input
                          type="text"
                          id="Saname"
                          defaultValue={e.userName}
                        />
                        <span id="UpdatecapErrA" className="error"></span>
                      </div>

                      <div className="md-form mb-5">
                        <label id="ParoSectionTable">Email</label>
                        <input
                          type="text"
                          id="Saname"
                          defaultValue={e.email}
                          readOnly
                        />
                        <span id="UpdatecapErrA" className="error"></span>
                      </div>
                    </div>

                    <div className="modal-footer d-flex justify-content-center">
                      <button className="Paro-adduser-button" type="submit">
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default UserViewMain;
